// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gx-3";
export var downloadButton = "_gx-4";
export var fileContainer = "_gx-9 _gx-7";
export var fileContainerBase = "_gx-7";
export var fileContainerFixedHeight = "_gx-8 _gx-7";
export var fileInfo = "_gx-5";
export var fileInfoWidthRestricted = "_gx-6";
export var fileType = "_gx-1";
export var fileTypeName = "_gx-2";
export var image = "_gx-0";
export var link = "_gx-b";
export var overflowEllipsis = "_gx-a";